import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateContactSchema } from '@app/models/dictionaries';
import Api from '@app/services/api';

export const useCreateContactQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (data: CreateContactSchema) => {
      const res = await Api.dictionaries.postContact(data);
      await client.invalidateQueries(['getContacts']);
      return res;
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
